import React from "react";
import { NotificationStyled } from "./NotificationStyled";
import { TNotificationType } from "./NotificationTypes";
var Notification = function (_a) {
    var message = _a.message, type = _a.type;
    var notificationClass = "";
    switch (type) {
        case TNotificationType.success:
            notificationClass = "success";
            break;
        case TNotificationType.error:
            notificationClass = "error";
            break;
        case TNotificationType.warning:
            notificationClass = "warning";
            break;
        default:
            break;
    }
    return (React.createElement(NotificationStyled, { className: "notification " + notificationClass },
        React.createElement("span", null, message)));
};
export default Notification;
//# sourceMappingURL=Notification.js.map